/**
 * Safe localStorage wrapper.
 * All operations are wrapped in try/catch so the app never crashes
 * in private-browsing mode or when storage is full/disabled.
 */

export const storage = {
  getItem(key) {
    try {
      return localStorage.getItem(key);
    } catch {
      return null;
    }
  },

  setItem(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch {
      // Storage quota exceeded or unavailable — silently ignore
    }
  },

  removeItem(key) {
    try {
      localStorage.removeItem(key);
    } catch {
      // Ignore
    }
  },

  /** Parse a JSON value stored under key. Returns fallback on any error. */
  getJSON(key, fallback = null) {
    try {
      const raw = localStorage.getItem(key);
      return raw ? JSON.parse(raw) : fallback;
    } catch {
      return fallback;
    }
  },

  /** Stringify value and store it under key. */
  setJSON(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch {
      // Ignore
    }
  },
};

export default storage;
